export default __webpack_public_path__ + "static/media/moteur.6e062217.png";